export const RESIGNATION_AGREEMENT = (person_id, date) =>
  `/resignation_agreement/${person_id}/${date}/manage`;
